import http from './http'

export function listPublicStudio(apiKey) {
  return http.get('/public/studio', {
    headers: apiKey ? { 'X-API-Key': apiKey } : {},
    skipAuthRedirect: true,
  })
}

export function getPublicStudio(id, apiKey, page) {
  const params = {}
  if (page !== undefined && page !== null && page !== '') {
    params.page = page
  }
  return http.get(`/public/studio/${id}`, {
    params,
    headers: apiKey ? { 'X-API-Key': apiKey } : {},
    skipAuthRedirect: true,
  })
}

export function uploadPublicStudioImage(file, apiKey) {
  const formData = new FormData()
  formData.append('file', file)
  return http.post('/public/studio/upload', formData, {
    headers: apiKey ? { 'X-API-Key': apiKey } : {},
    skipAuthRedirect: true,
  })
}

export function downloadPublicStudio(id, apiKey, payload) {
  const { page, format, fields } = payload || {}
  return http.post(`/public/studio/${id}/download`, {
    page: page || 1,
    format: format || 'png',
    fields: fields || {},
  }, {
    headers: apiKey ? { 'X-API-Key': apiKey } : {},
    responseType: 'blob',
    skipAuthRedirect: true,
  })
}
